import { Component, Input } from "@angular/core";
import { IColumnHeader } from "../../models/IColumnHeader";
import './report-column.component.scss';

@Component({
    selector: 'v-report-column',
    template: require('./report-column.component.html')
})
export class VReportColumnComponent {
    @Input() column: IColumnHeader;
    @Input() highlightText: string;
    constructor() { }

    ngOnInit(): void {
        console.log()
    }
}
